module.exports = __webpack_public_path__ + "static/media/footer_greenblue.5b1e2d90.png";